angular.module('schemaForm').config(['schemaFormProvider',
    'schemaFormDecoratorsProvider', 'sfPathProvider',
    function(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {

        // First, we want this to be the default for a combination of schema parameters
        var spinner = function (name, schema, options) {
            if ((schema.type === 'integer' || schema.type === 'number') && schema.format == 'spinner') {
                // Initiate a form provider
                var f = schemaFormProvider.stdFormObj(name, schema, options);
                f.key = options.path;
                f.type = 'spinner';
                // Add it to the lookup dict (for internal use)
                options.lookup[sfPathProvider.stringify(options.path)] = f;
                return f;
            }
        };
        // Add our default to the defaults array
        schemaFormProvider.defaults.integer.unshift(spinner);
        schemaFormProvider.defaults.number.unshift(spinner);

        // Second, we want it to show if someone have explicitly set the form type
        schemaFormDecoratorsProvider.addMapping('bootstrapDecorator', 'spinner',
            'app/schema-form-component/angular-schema-form-spinner/angular-schema-form-spinner.html');
    }]);
